import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { Component, EventEmitter, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-guest-login',
  standalone: true,
  imports: [RouterModule, ButtonComponent, NgIf],
  templateUrl: './guest-login.component.html',
  styleUrl: './guest-login.component.scss',
    animations: [
      trigger('slideDialog', [
        state(
          'hidden',
          style({
            transform: 'translate(-50%, 100%)',
          })
        ),
        state(
          'visible',
          style({
            transform: 'translate(-50%, -50%)',
          })
        ),
        transition('hidden => visible', [
          animate(
            '500ms ease-out',
            keyframes([
              style({ transform: 'translate(-50%, 100%)', offset: 0 }),
              style({ transform: 'translate(-50%, -55%)', offset: 0.7 }),
              style({ transform: 'translate(-50%, -50%)', offset: 1 }),
            ])
          ),
        ]),
        transition('visible => hidden', [
          animate(
            '300ms ease-in',
            style({
              transform: 'translate(-50%, 100%)',
            })
          ),
        ]),
      ]),
    ],
})
export class GuestLoginComponent {
  @Output() close = new EventEmitter<boolean>();
  slideState = 'hidden';

  ngOnInit():void {
    setTimeout(() => (this.slideState = 'visible'), 0);
  }
  
  closeModal(): void {
    this.slideState = 'hidden';
    setTimeout(() => this.close.emit(), 300);
  }

}
